import { ref, watch, onMounted, readonly } from 'vue';
import { storeToRefs } from 'pinia';
import { useChartStore } from '@/stores/chartStore';
import { useSymbolInformation } from '@/composables/useSymbolInformation';

const symbolIsCryptoMapCache = new Map<string, boolean>();

const isViewingCryptoSymbol = ref(false);
let isAlreadyWatching = false;

export function useCryptoSymbolCheck() {
  const chartStore = useChartStore();
  const { isCryptoSymbol } = useSymbolInformation();

  const { symbol } = storeToRefs(chartStore);

  function mountHook() {
    if (isAlreadyWatching)
      return;

    async function handleSymbolChanged() {
      const symbolCopy = symbol.value;

      if (symbolIsCryptoMapCache.has(symbolCopy)) {
        isViewingCryptoSymbol.value = symbolIsCryptoMapCache.get(symbolCopy)!;
        return;
      }

      isViewingCryptoSymbol.value = false;
      const isCrypto = await isCryptoSymbol(symbolCopy);
      symbolIsCryptoMapCache.set(symbolCopy, isCrypto);

      if (symbolCopy !== symbol.value) {
        return;
      }

      isViewingCryptoSymbol.value = isCrypto;
    }

    handleSymbolChanged();
    watch(symbol, handleSymbolChanged);

    isAlreadyWatching = true;
  }

  onMounted(mountHook);

  return {
    isViewingCryptoSymbol: readonly(isViewingCryptoSymbol)
  };
}
